// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__310az","label":"styles_label__35Wsk"};